var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeerbitBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 18,
    viewBox: "0 0 115 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_113116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00146484 0.000852585V17.9098H18.4559V0.000852585H-0.00146484Z",
    fill: "#FF3C38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58008 10.2272L15.9535 10.2933L15.9921 2.69087L2.61795 2.62524L2.58008 10.2272ZM13.4085 7.74909L5.19214 7.70807L5.2047 5.17517L13.421 5.21619L13.4085 7.74909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56745 12.7638L15.9408 12.8298L15.933 14.4113C15.9317 14.6637 15.8299 14.9052 15.6499 15.0827C15.4699 15.2602 15.2265 15.3593 14.9733 15.358L2.55469 15.2965L2.56745 12.7638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8549 2.71814L34.5573 2.7811L34.5482 4.57833C34.5469 4.77398 34.4678 4.96112 34.3282 5.09868C34.1886 5.23623 33.9999 5.31294 33.8035 5.31195L24.3829 5.2654L24.3704 7.79358L34.5315 7.84383L34.4939 15.4436L22.5326 15.3845C22.3361 15.3832 22.1482 15.3043 22.0101 15.165C21.8721 15.0257 21.7952 14.8374 21.7964 14.6416L21.8055 12.8444L31.9674 12.8947L31.9802 10.3636L21.817 10.3134L21.8549 2.71814Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0864 5.32894L37.0961 2.79358L49.7989 2.85634L49.7862 5.3917L37.0864 5.32894Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7634 12.9863L49.7544 14.788C49.7533 14.9838 49.6743 15.1711 49.5347 15.3088C49.3951 15.4465 49.2064 15.5234 49.0099 15.5225L37.0518 15.4632L37.0814 7.8606L49.7745 7.92335L49.762 10.4552L39.5955 10.405L39.5829 12.9367L49.7634 12.9863Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3286 5.40446L52.3383 2.8689L65.0409 2.93165L65.0283 5.46722L52.3286 5.40446Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0051 13.0616L64.9962 14.8633C64.9952 15.0591 64.9162 15.2464 64.7766 15.3841C64.637 15.5219 64.4482 15.5987 64.2517 15.5978L52.2891 15.5387L52.3195 7.93713L65.0141 7.99866L65.0015 10.5303L54.834 10.4801L54.8215 13.012L65.0051 13.0616Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5238 3.08241L82.822 3.01965L82.7588 15.6897L94.3496 15.7469C94.4956 15.7476 94.6403 15.7196 94.7755 15.6646C94.9107 15.6095 95.0337 15.5284 95.1374 15.4259C95.2411 15.3235 95.3235 15.2017 95.38 15.0675C95.4364 14.9332 95.4658 14.7892 95.4663 14.6437L95.4869 10.677L94.2228 9.40543L95.4989 8.14514L95.5238 3.08241ZM92.9327 13.1962L85.3124 13.1584L85.325 10.6274L92.9452 10.6649L92.9327 13.1962ZM92.958 8.13345L85.3365 8.09571L85.3492 5.56404L92.9706 5.60157L92.958 8.13345Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0638 3.09509L100.604 3.1076L100.541 15.769L99.1118 15.7621C98.8172 15.7605 98.5352 15.6424 98.328 15.4338C98.1207 15.2251 98.005 14.943 98.0064 14.6494L98.0638 3.09509Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.298 3.11597L115 3.17893L114.987 5.7106L109.907 5.68558L109.856 15.8153L108.426 15.8084C108.132 15.8068 107.85 15.6887 107.643 15.4801C107.435 15.2714 107.32 14.9893 107.321 14.6957L107.366 5.67307L102.285 5.64784L102.298 3.11597Z",
    fill: "#151C30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5799 2.94434L67.5672 5.47601L77.7294 5.52625L77.7176 8.05792L67.5555 8.00768L67.5176 15.6058L69.3175 15.6148C69.5138 15.6155 69.7023 15.5386 69.8418 15.4009C69.9812 15.2632 70.0601 15.076 70.0611 14.8803L70.0827 10.5549L72.6227 10.5674L76.3687 14.8908C76.5761 15.1301 76.8326 15.3224 77.1208 15.4547C77.4091 15.587 77.7224 15.6563 78.0397 15.6579L80.2196 15.6685L75.7605 10.5802L80.2441 10.6033L80.2819 3.00812L67.5799 2.94434Z",
    fill: "#151C30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_113116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerbitBrandLogo);
export default __webpack_public_path__ + "static/media/SeerbitBrandLogo.f4a12fdeff6920a53cb2ea0cf9441730.svg";
export { ForwardRef as ReactComponent };